<template>
  <!-- 条件管理页：只做外壳（卡片 + 标题），表单本体在 ConditionForm，
       与推送任务页的条件对话框共用同一份逻辑与校验 -->
  <div class="condition-edit">
    <el-card>
      <div slot="header" class="card-header">
        <span>{{ isEdit ? $t('autoPush.condEditTitle') : $t('autoPush.condNewTitle') }}</span>
      </div>
      <condition-form
        :condition-id="conditionId"
        @saved="handleSaved"
        @cancel="$router.back()"
      />
    </el-card>
  </div>
</template>

<script>
import ConditionForm from './ConditionForm.vue'

export default {
  name: 'AutoPushConditionEdit',
  components: { ConditionForm },
  computed: {
    // 路由带 id = 编辑，否则新建
    conditionId() {
      return this.$route.params.id || null
    },
    isEdit() {
      return !!this.conditionId
    }
  },
  methods: {
    // 独立页面：保存后回到列表；任务页对话框走的是另一套（选中新条件）
    handleSaved() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.card-header {
  font-weight: bold;
  font-size: 16px;
}
</style>
